export default {
    All: 'all',
    Conclusion: 'conclusion',
    Files: 'files',
}
